module.exports = __webpack_public_path__ + "static/media/botox.5f214a6e.svg";